import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=60681c1a&"
import script from "./js/supplier.js?vue&type=script&lang=js&"
export * from "./js/supplier.js?vue&type=script&lang=js&"
import style0 from "./supplier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports